import React from "react";
import { Modal } from "antd";
import { ApartmentOutlined } from "@ant-design/icons";
import CascadePlanHierarchyManager from "../CascadePlanHierarchyManager";

function CascadePlanHierarchyModal({ visible, onCancel, planId, planTitle, onHierarchyChange }) {
  return (
    <Modal
      title={
        <div className="flex items-center space-x-2">
          <ApartmentOutlined className="text-blue-500" />
          <span className="font-bold">Cascade Plans Hierarchy Management</span>
        </div>
      }
      open={visible}
      onCancel={onCancel}
      footer={null}
      width={800}
      className="hierarchy-modal"
    >
      {planTitle && (
        <div className="mb-4 p-3 bg-blue-50 rounded-lg border border-blue-200">
          <div className="text-sm text-blue-700">
            <strong>Managing cascade plans for:</strong> {planTitle}
          </div>
        </div>
      )}
      
      <CascadePlanHierarchyManager
        planId={planId}
        onHierarchyChange={onHierarchyChange}
      />
    </Modal>
  );
}

export default CascadePlanHierarchyModal;